export const CONTENT_TAB_THEMES = {
  home: {
    accent: "#2563eb",
    selected: "#1d4ed8",
    labelBackground: "#dbeafe",
  },
  bonus: {
    accent: "#059669",
    selected: "#047857",
    labelBackground: "#d1fae5",
  },
  twoForOne: {
    accent: "#ed3a3a",
    selected: "#c82020",
    labelBackground: "#fee9e9",
  },
} as const;

export const CONTENT_TAB_THEME_CSS_VARS: Record<string, string> = {
  "--content-tab-home-accent": CONTENT_TAB_THEMES.home.accent,
  "--content-tab-home-selected": CONTENT_TAB_THEMES.home.selected,
  "--content-tab-home-label-bg": CONTENT_TAB_THEMES.home.labelBackground,
  "--content-tab-bonus-accent": CONTENT_TAB_THEMES.bonus.accent,
  "--content-tab-bonus-selected": CONTENT_TAB_THEMES.bonus.selected,
  "--content-tab-bonus-label-bg": CONTENT_TAB_THEMES.bonus.labelBackground,
  "--content-tab-two-for-one-accent": CONTENT_TAB_THEMES.twoForOne.accent,
  "--content-tab-two-for-one-selected": CONTENT_TAB_THEMES.twoForOne.selected,
  "--content-tab-two-for-one-label-bg": CONTENT_TAB_THEMES.twoForOne.labelBackground,
};
